import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { PromoFlagIcon } from 'apps/promo/components/common/promo-flag-icon/PromoFlagIcon';
import { PromoText } from 'apps/promo/components/common/promo-text/PromoText';
import { resolveArguments, getLangCountryPrefix } from 'apps/promo/helpers/utils';

import styles from './PromoCountryItemPlain.module.css';

const PromoCountryItem = (props) => {
    const { urlTemplate, isSendOperation, receiverSlug, senderSlug, name, countryCode } = props;
    let uri = getLangCountryPrefix(props.lang, props.country) + resolveArguments(urlTemplate, [isSendOperation ? receiverSlug : senderSlug]);
    return (
        <a href={uri} className={styles.countryLink}>
            <span className={styles.flagWrapper}>
                <PromoFlagIcon name={countryCode} size={'24px'} />
            </span>
            <div className={styles.countryName}>
                <PromoText variant={props.isGeoSection ? 'span' : 'subheader'} color="gray40" nowrap>
                    {name}
                </PromoText>
            </div>
        </a>
    );
};

PromoCountryItem.propTypes = {
    urlTemplate: PropTypes.string.isRequired,
    countryCode: PropTypes.string.isRequired,
    receiverSlug: PropTypes.string,
    senderSlug: PropTypes.string,
    isSendOperation: PropTypes.bool,
    name: PropTypes.string,
    isGeoSection: PropTypes.bool,
};

const mapStateToProps = (state) => {
    return {
        lang: state.language.lang,
        country: state.app.country,
    };
};

export default connect(mapStateToProps)(PromoCountryItem);
